const MIN_YEAR = 1900

export function maskMonthYear(value) {
  const digits = String(value || '').replace(/\D/g, '').slice(0, 6)
  return digits.length > 2 ? `${digits.slice(0, 2)}/${digits.slice(2)}` : digits
}

export function monthYearError(masked, currentMonth) {
  if (!masked) return null
  if (!/^\d{2}\/\d{4}$/.test(masked)) return 'Informe mês e ano no formato MM/AAAA.'

  const [mes, ano] = masked.split('/')
  if (Number(mes) < 1 || Number(mes) > 12) return 'Mês inválido.'
  if (Number(ano) < MIN_YEAR) return 'Ano inválido.'
  if (`${ano}-${mes}` > currentMonth) return 'Desde quando não pode ser no futuro.'

  return null
}

export function monthYearToApi(masked) {
  if (!masked) return null
  const [mes, ano] = masked.split('/')
  return `${ano}-${mes}`
}
